export function assignTimelineLanes(entries) {
  const laneEnds = [];
  return [...entries].sort((a, b) => a.range.start - b.range.start).map(entry => {
    let lane = laneEnds.findIndex(end => end <= entry.range.start);
    if (lane < 0) lane = laneEnds.length;
    laneEnds[lane] = entry.range.end;
    return { ...entry, lane };
  });
}
